var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 80,
    viewBox: "0 0 215 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.134 0H15.2975C6.84893 0 0 6.84893 0 15.2975V64.7025C0 73.1511 6.84893 80 15.2975 80H199.134C207.582 80 214.431 73.1511 214.431 64.7025V15.2975C214.431 6.84893 207.582 0 199.134 0Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.134 2.57317C206.15 2.57317 211.858 8.28133 211.858 15.2975V64.6982C211.858 71.7144 206.15 77.4225 199.134 77.4225H15.2975C8.28133 77.4225 2.57318 71.7144 2.57318 64.6982V15.2975C2.57318 8.28133 8.28133 2.57317 15.2975 2.57317H199.129M199.134 0H15.2975C6.84893 0 0 6.84893 0 15.2975V64.6982C0 73.1468 6.84893 79.9957 15.2975 79.9957H199.129C207.578 79.9957 214.427 73.1468 214.427 64.6982V15.2975C214.427 6.84893 207.578 0 199.129 0H199.134Z",
    fill: "url(#paint0_linear_2899_6081)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1074 22.9976H97.9128V27.9595L83.5245 47.1854H97.9128V54.0086H73.1074V49.0467L87.5558 29.8208H73.1074V22.9976Z",
    fill: "url(#paint1_linear_2899_6081)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.971 54.5618C112.407 54.5618 110.228 54.1373 108.427 53.2924C106.63 52.4475 105.15 51.3711 103.992 50.0674C102.835 48.7636 101.998 47.3484 101.479 45.8173C100.96 44.2863 100.703 42.841 100.703 41.4772V22.9976H108.144V41.2928C108.144 42.4122 108.328 43.3599 108.701 44.1448C109.075 44.9296 109.568 45.5943 110.19 46.1304C110.811 46.6665 111.532 47.061 112.36 47.3098C113.187 47.5585 114.054 47.6829 114.963 47.6829C115.872 47.6829 116.738 47.5585 117.566 47.3098C118.394 47.061 119.118 46.6708 119.736 46.1304C120.358 45.5943 120.851 44.9339 121.224 44.1448C121.597 43.3599 121.782 42.4079 121.782 41.2928V22.9976H129.222V41.4772C129.222 42.841 128.965 44.2906 128.446 45.8173C127.927 47.3484 127.091 48.7636 125.933 50.0674C124.775 51.3711 123.296 52.4433 121.499 53.2924C119.702 54.1373 117.519 54.5618 114.954 54.5618H114.971Z",
    fill: "url(#paint2_linear_2899_6081)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.286 22.4385C148.851 22.4385 151.029 22.863 152.831 23.7079C154.628 24.5571 156.107 25.6292 157.265 26.933C158.423 28.2367 159.259 29.6519 159.778 31.183C160.293 32.714 160.555 34.1593 160.555 35.5231V54.0028H153.114V35.7075C153.114 34.5924 152.929 33.6404 152.556 32.8555C152.183 32.0707 151.69 31.4103 151.068 30.8699C150.446 30.3338 149.726 29.9393 148.898 29.6905C148.07 29.4418 147.204 29.3174 146.295 29.3174C145.386 29.3174 144.515 29.4418 143.692 29.6905C142.864 29.9393 142.139 30.3338 141.522 30.8699C140.9 31.406 140.407 32.0707 140.033 32.8555C139.66 33.6404 139.476 34.5924 139.476 35.7075V54.0028H132.035V35.5231C132.035 34.1593 132.292 32.714 132.811 31.183C133.326 29.6562 134.167 28.2367 135.325 26.933C136.482 25.6292 137.962 24.5571 139.759 23.7079C141.556 22.863 143.739 22.4385 146.299 22.4385H146.286Z",
    fill: "url(#paint3_linear_2899_6081)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.342 22.5634C181.74 22.5634 183.931 22.9451 185.917 23.7127C187.902 24.4761 189.596 25.5611 191.003 26.9678C192.41 28.3745 193.495 30.0685 194.258 32.0541C195.021 34.0397 195.407 36.2312 195.407 38.6286V54.0076H187.967V51.0313C187.22 51.9833 186.075 52.811 184.523 53.5101C182.97 54.2091 181.058 54.5651 178.785 54.5651C176.512 54.5651 174.483 54.1834 172.583 53.4157C170.684 52.6524 169.05 51.5673 167.686 50.1607C166.322 48.754 165.258 47.06 164.491 45.0744C163.727 43.0887 163.346 40.8972 163.346 38.4999C163.346 36.1026 163.727 33.9196 164.491 31.9555C165.254 29.9913 166.339 28.3187 167.746 26.9335C169.153 25.5483 170.838 24.4761 172.802 23.7084C174.766 22.9451 176.945 22.5591 179.347 22.5591L179.342 22.5634ZM187.962 38.5642C187.962 35.6694 187.186 33.4179 185.638 31.8054C184.085 30.1928 182.01 29.3866 179.407 29.3866C176.803 29.3866 174.715 30.1928 173.145 31.8054C171.576 33.4179 170.791 35.6737 170.791 38.5642C170.791 41.4548 171.576 43.7106 173.145 45.3231C174.715 46.9356 176.803 47.7419 179.407 47.7419C182.01 47.7419 184.09 46.9356 185.638 45.3231C187.19 43.7106 187.962 41.459 187.962 38.5642Z",
    fill: "url(#paint4_linear_2899_6081)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.061 22.9969H31.5018V57.0443C31.5018 58.7383 31.326 60.3294 30.9743 61.8175C30.6226 63.3057 30.0137 64.618 29.1431 65.7545C28.2768 66.891 27.1188 67.7916 25.6693 68.452C24.224 69.1125 22.4013 69.4427 20.2141 69.4427H19.6266C19.4422 69.4427 19.2449 69.4213 19.0391 69.3784V62.5552C20.6087 62.5552 21.8395 62.1006 22.7273 61.1914C23.615 60.2822 24.061 58.7726 24.061 56.6626V22.9969ZM23.3792 14.068C23.3792 12.8286 23.8123 11.7736 24.6829 10.9073C25.5535 10.041 26.5828 9.60352 27.7836 9.60352C28.9844 9.60352 30.0694 10.0367 30.9143 10.9073C31.7591 11.7736 32.1837 12.8286 32.1837 14.068C32.1837 15.3074 31.7591 16.3624 30.9143 17.2287C30.0651 18.095 29.023 18.5324 27.7836 18.5324C26.5442 18.5324 25.5492 18.0993 24.6829 17.2287C23.8166 16.3624 23.3792 15.3074 23.3792 14.068Z",
    fill: "url(#paint5_linear_2899_6081)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1259 44.611C37.1259 40.5797 38.6956 36.7928 41.5432 33.9409C44.3952 31.089 48.182 29.5236 52.2133 29.5236C56.2446 29.5236 60.0315 31.0933 62.8834 33.9409C65.7354 36.7928 67.3007 40.5797 67.3007 44.611C67.3007 46.5623 66.9319 48.4579 66.2285 50.2205C68.8746 47.0555 70.4657 42.977 70.4657 38.5297C70.4657 28.4472 62.2959 20.2773 52.2133 20.2773C42.1308 20.2773 33.9609 28.4472 33.9609 38.5297C33.9609 42.977 35.552 47.0555 38.1981 50.2205C37.4948 48.4622 37.1259 46.5666 37.1259 44.611Z",
    fill: "url(#paint6_linear_2899_6081)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2164 56.7805C55.5774 56.7805 58.302 54.0559 58.302 50.6949C58.302 47.334 55.5774 44.6094 52.2164 44.6094C48.8555 44.6094 46.1309 47.334 46.1309 50.6949C46.1309 54.0559 48.8555 56.7805 52.2164 56.7805Z",
    fill: "url(#paint7_linear_2899_6081)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2056 50.6958C43.2056 45.7296 47.2455 41.6897 52.2118 41.6897C57.178 41.6897 61.2179 45.7296 61.2179 50.6958C61.2179 51.5493 61.0978 52.377 60.8705 53.1618C63.0405 50.966 64.3786 47.9468 64.3786 44.6146C64.3786 37.8943 58.932 32.4478 52.2118 32.4478C45.4915 32.4478 40.0449 37.8943 40.0449 44.6146C40.0449 47.9468 41.383 50.966 43.553 53.1618C43.33 52.377 43.2056 51.5536 43.2056 50.6958Z",
    fill: "url(#paint8_linear_2899_6081)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2164 56.7805C55.5774 56.7805 58.302 54.0559 58.302 50.6949C58.302 47.334 55.5774 44.6094 52.2164 44.6094C48.8555 44.6094 46.1309 47.334 46.1309 50.6949C46.1309 54.0559 48.8555 56.7805 52.2164 56.7805Z",
    fill: "url(#paint9_linear_2899_6081)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2899_6081",
    x1: 0,
    y1: 40,
    x2: 214.431,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2899_6081",
    x1: 73.1074,
    y1: 38.5009,
    x2: 97.9128,
    y2: 38.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2899_6081",
    x1: 100.707,
    y1: 38.7797,
    x2: 129.235,
    y2: 38.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2899_6081",
    x1: 132.022,
    y1: 38.2206,
    x2: 160.55,
    y2: 38.2206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2899_6081",
    x1: 163.341,
    y1: 38.5642,
    x2: 195.403,
    y2: 38.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2899_6081",
    x1: 19.0391,
    y1: 39.5252,
    x2: 32.1837,
    y2: 39.5252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2899_6081",
    x1: 33.9609,
    y1: 35.2446,
    x2: 70.4657,
    y2: 35.2446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2899_6081",
    x1: 46.1351,
    y1: 50.6949,
    x2: 58.302,
    y2: 50.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2899_6081",
    x1: 40.0406,
    y1: 42.8005,
    x2: 64.3786,
    y2: 42.8005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2899_6081",
    x1: 46.1351,
    y1: 50.6949,
    x2: 58.302,
    y2: 50.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFFA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DDAC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).f300ce416efa5df22f28841f383422ba.svg";
export { ForwardRef as ReactComponent };